'use client';

import { Provider as JotaiProvider } from 'jotai';
import { SessionProvider } from 'next-auth/react';
import AddUserIdToHotjarScript from '~/components/analytics/AddUserIdToHotjarScript';
import PostHogProvider from '~/components/posthog/PostHogProvider';
import { I18nProviderClient } from '~/locales/client';
import { LocaleEnum } from '~/locales/resources';
import '~/styles/index.css';
import CookieHandler from './_components/CookieHandler';
import Tracking from './_components/Tracking';

type ProviderProps = {
  children: React.ReactNode;
  locale: LocaleEnum;
};

/**
 * Providers for the app
 * - Has to be client component, because all the providers/handlers are client components
 * @param children - The children to render
 * @param locale - The locale to use
 */
const Providers = ({ children, locale }: ProviderProps) => {
  return (
    <SessionProvider>
      <I18nProviderClient locale={locale}>
        <JotaiProvider>
          <CookieHandler />
          <PostHogProvider />
          {children}
          <Tracking locale={locale as LocaleEnum} />
        </JotaiProvider>
      </I18nProviderClient>
      <AddUserIdToHotjarScript />
    </SessionProvider>
  );
};

export default Providers;
